export const initialBookingFormState = {
  title: "",
  eventDate: "",
  city: "",
  payout: "",
  currency: "DKK",
  depositAmount: "",
  notes: "",
  cancellationPolicy: "",
  techRequirements: "",
};

export const initialAuthFormState = {
  username: "",
  password: "",
  confirmPassword: "",
  name: "",
  email: "",
  userType: "artist",
};

export const initialProfileFormState = {
  bio: "",
  experienceLevel: "",
  website: "",
  genres: "",
  instruments: "",
  socialLinks: "",
  coverImageUrl: "",
};

export const initialGigFormState = {
  title: "",
  date: "",
  time: "",
  city: "",
  payout: "",
  description: "",
  genres: "",
  tags: "",
};

export const DEMO_GIGS = [
  {
    id: "demo-1",
    title: "Sunset Lounge Residency",
    date: new Date().toISOString(),
    city: "Copenhagen",
    payout: 2500,
    genres: ["Jazz", "Soul"],
    tags: ["Intimate", "Resident"],
  },
  {
    id: "demo-2",
    title: "Midnight Jazz Festival",
    date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 7).toISOString(),
    city: "Aarhus",
    payout: 3800,
    genres: ["Jazz", "Fusion"],
    tags: ["Outdoor", "Festival"],
  },
  {
    id: "demo-3",
    title: "Corporate Gala",
    date: new Date(Date.now() + 1000 * 60 * 60 * 24 * 14).toISOString(),
    city: "Odense",
    payout: 1900,
    genres: ["Pop", "Covers"],
    tags: ["Corporate", "Private"],
  },
];

export const DEMO_ARTISTS = [
  {
    id: "demo-artist-1",
    name: "Midnight Quartet",
    username: "midnightquartet",
    bio: "Contemporary jazz quartet playing intimate venues and festivals.",
    experience_level: "Touring",
    website: "https://example.com/midnightquartet",
    genres: ["Jazz", "Soul"],
    instruments: ["Saxophone", "Piano", "Bass", "Drums"],
    cover_image_url:
      "https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=1200&q=60",
  },
  {
    id: "demo-artist-2",
    name: "Neon Waves",
    username: "neonwaves",
    bio: "Synth-driven pop duo with a high-energy live set.",
    experience_level: "Experienced",
    website: "https://example.com/neonwaves",
    genres: ["Pop", "Electronic"],
    instruments: ["Vocals", "Synths"],
    cover_image_url:
      "https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=1200&q=60",
  },
  {
    id: "demo-artist-3",
    name: "Hardgroove Collective",
    username: "hardgroovecollective",
    bio: "Funk and soul band bringing dance-floor energy.",
    experience_level: "Pro",
    genres: ["Funk", "Soul"],
    instruments: ["Guitar", "Bass", "Drums", "Horns"],
    cover_image_url:
      "https://images.unsplash.com/photo-1485579149621-3123dd979885?auto=format&fit=crop&w=1200&q=60",
  },
  {
    id: "demo-artist-4",
    name: "String & Bow",
    username: "stringandbow",
    bio: "Acoustic duo for cozy atmospheres and weddings.",
    experience_level: "Seasoned",
    genres: ["Acoustic", "Classical"],
    instruments: ["Violin", "Guitar"],
    cover_image_url:
      "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?auto=format&fit=crop&w=1200&q=60",
  },
  {
    id: "demo-artist-5",
    name: "City Lights Trio",
    username: "citylightstrio",
    bio: "Smooth jazz for restaurants and lounges.",
    experience_level: "Experienced",
    genres: ["Jazz"],
    instruments: ["Piano", "Bass", "Drums"],
  },
  {
    id: "demo-artist-6",
    name: "Atlas Rock",
    username: "atlasrock",
    bio: "Classic and modern rock covers, festival-ready.",
    experience_level: "Touring",
    genres: ["Rock"],
    instruments: ["Guitar", "Bass", "Drums", "Vocals"],
  },
  {
    id: "demo-artist-7",
    name: "Pulse Techno",
    username: "pulsetechno",
    bio: "Techno DJ delivering late-night club sets.",
    experience_level: "Club",
    genres: ["Techno", "Electronic"],
    instruments: ["DJ"],
  },
  {
    id: "demo-artist-8",
    name: "Folk & Fire",
    username: "folkandfire",
    bio: "Nordic folk with modern storytelling.",
    experience_level: "Emerging",
    genres: ["Folk", "Acoustic"],
    instruments: ["Guitar", "Vocals"],
  },
  {
    id: "demo-artist-9",
    name: "Metro Classica",
    username: "metroclassica",
    bio: "String quartet for receptions and special events.",
    experience_level: "Professional",
    genres: ["Classical"],
    instruments: ["Violin", "Viola", "Cello"],
  },
];
